require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./das-geruest-ist-endlich-ab.json") })
        }
      }, "path---das-geruest-ist-endlich-ab");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---das-geruest-ist-endlich-ab!./.cache/json/das-geruest-ist-endlich-ab.json
// module id = 413
// module chunks = 231608221292675